export enum LegendOrientation {
  H = 'horizontal',
  V = 'vertical',
}
